import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportManagementProfileEndpoint } from '../constants/transport-management-profile-endpoint';
import { TransportManagementProfileReport } from '../../../../models/profile-report';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementReportService {
  constructor(private http: WrapperHttpService) {}

  getReport(): Observable<TransportManagementProfileReport> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}${TransportManagementProfileEndpoint.Report}${TransportManagementProfileEndpoint.Fields}`;
    return this.http.withLoading().get<TransportManagementProfileReport>(url);
  }
}
